import SEO from "@/components/SEO";
import QuickExit from "@/components/QuickExit";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import HowTherapyHelps from "@/components/HowTherapyHelps";
import QuestionnaireSection from "@/components/QuestionnaireSection";
import AboutSection from "@/components/AboutSection";
import TherapyStyleSection from "@/components/TherapyStyleSection";
import IssuesSection from "@/components/IssuesSection";
import MidPageCTA from "@/components/MidPageCTA";
import WhatToExpect from "@/components/WhatToExpect";
// import EndorsementsSection from "@/components/EndorsementsSection";
import PricingSection from "@/components/PricingSection";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import CrisisResources from "@/components/CrisisResources";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <main>
      <SEO
        title="Stillwater Therapy | Dallas Psychotherapist | Ashley Bass, LMFT"
        description="Individual & family therapy in Dallas, TX with Ashley Bass, LMFT. Free consultation. In-network with Aetna, Blue Cross Blue Shield, Cigna, and United Healthcare."
        path="/"
      />
      <QuickExit />
      <Header />
      <HeroSection />
      <HowTherapyHelps />
      <QuestionnaireSection />
      <AboutSection />
      <TherapyStyleSection />
      <IssuesSection />
      <MidPageCTA />
      <WhatToExpect />
      {/* <EndorsementsSection /> hidden for now, will use later */}
      <PricingSection />
      <FAQSection />
      <ContactSection />
      <CrisisResources />
      <Footer />
    </main>
  );
};

export default Index;
